import Swiper from "swiper";
//import { Pagination } from "swiper/modules";

// Attendre que le DOM soit chargé
document.addEventListener('DOMContentLoaded', function() {
    const featuresElement = document.querySelector('#accessories .swiper');
    
    if (featuresElement) {
        const featuresSwiperInit = new Swiper(featuresElement, {
            //modules: [Pagination],
            slidesPerView: '1.2',
            spaceBetween: 30,
            loop: false,
            // autoplay: {
            //     delay: 1000,
            //     disableOnInteraction: false,
            // }
            breakpoints: {
                640: {
                    slidesPerView: '2.2',
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: '4.2',
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: '5.3',
                    spaceBetween: 40,
                },
                1440: {
                    slidesPerView: '6.3',
                    spaceBetween: 40,
                },
                1920: {
                    slidesPerView: '7.3',
                    spaceBetween: 40,
                },
            }
        });
    }
});